import React from 'react';
import { useAppContext } from '../../Store/Store';

export default function Footer() {
  const { resolveMediaUrl, logoRedirectUrl, product, brand, style } =
    useAppContext();
  const computedFooterLogo = product?.footer_logo || style?.footer_logo || '';
  const computedFooterLogoUrl =
    product?.footer_logo_url || style?.footer_logo_url || '';
  const computedPrivacyPolicyUrl = product?.privacy_policy_url || '';
  const computedProductImg = product?.product_img || '';
  // const isProductMode = product && computedProductImg && product.product_indication;

  const handlePrivacyPolicyClick = () => {
    if (computedPrivacyPolicyUrl) {
      window.open(computedPrivacyPolicyUrl, '_blank');
    } else {
      alert('Privacy policy is not available.');
    }
  };
  return (
    <footer className="footer">
      <a
        href={computedFooterLogoUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {computedFooterLogo && (
          <img
            src={resolveMediaUrl(computedFooterLogo)}
            alt="Footer Logo"
            style={{
              maxHeight: 'clamp(28px, 8vh, 80px)',
              maxWidth: 'min(60vw, 320px)',
              objectFit: 'contain',
            }}
          />
        )}
      </a>
      <button
        onClick={handlePrivacyPolicyClick}
        style={{
          fontSize: 'clamp(10px, 1.4vh, 14px)',
          textDecoration: 'underline',
          color: style?.privacy_policy_text_color || 'grey',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          marginTop: 'clamp(4px, 1vh, 12px)',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {style?.privacy_policy_indication || 'Privacy Policy'}
      </button>
    </footer>
  );
}
